import { formatStringWith } from '@cbgms/base/utils/helpers'
import { formatAddressStreetThenHouseNumber } from './formatAddressStreetThenHouseNumber'
import { formatAddressPostalCodeThenCity } from './formatAddressPostalCodeThenCity'
import { formatAddressHouseNumberThenStreet } from './formatAddressHouseNumberThenStreet'
import { formatAddressCityThenPostalCode } from './formatAddressCityThenPostalCode'
import { AddressTypes, IAddress } from './address'
import { CountryCode } from '@carsys/enums/country-code'

export const formatAdressFull = (address: Partial<IAddress>, type: AddressTypes, country: CountryCode) => {
  switch (country) {
    case CountryCode.NL:
    case CountryCode.BE:
    case CountryCode.DE:
      return formatStringWith(', ')(formatAddressStreetThenHouseNumber(address, type), formatAddressPostalCodeThenCity(address, type))
    case CountryCode.GB:
      return formatStringWith(', ')(formatAddressHouseNumberThenStreet(address, type), formatAddressCityThenPostalCode(address, type))
    default:
      return formatStringWith(', ')(formatAddressStreetThenHouseNumber(address, type), formatAddressPostalCodeThenCity(address, type))
  }
}
